import { Button as UIButton } from '@orbital/slot-lib';

export const mouseOverMixin = {
	mouseOverHandler() {
		if (this.hover) {
			window.sm.play({ name: 'general_hover_sfx' });
		}
	}
};

class Button extends UIButton {}

Object.assign(Button.prototype, mouseOverMixin);

export default Button;
